import type { CSSProperties } from 'react';

import styles from './Skeleton.module.css';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({ width, height = 14, circle, className, style }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={[styles.skeleton, circle && styles.circle, className]
        .filter(Boolean)
        .join(' ')}
      style={{ width, height, ...style }}
    />
  );
}

export interface SkeletonTextProps {
  lines?: number;
  className?: string;
}

export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <div
      className={[styles.text, className].filter(Boolean).join(' ')}
      role="status"
      aria-label="Загрузка"
    >
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} width="100%" height={12} />
      ))}
    </div>
  );
}

export interface SkeletonRowsProps {
  rows?: number;
  className?: string;
}

export function SkeletonRows({ rows = 5, className }: SkeletonRowsProps) {
  return (
    <div
      className={[styles.rows, className].filter(Boolean).join(' ')}
      role="status"
      aria-label="Загрузка"
    >
      {Array.from({ length: rows }, (_, index) => (
        <span key={index} className={`${styles.skeleton} ${styles.row}`} aria-hidden="true" />
      ))}
    </div>
  );
}
